import { createContext } from 'react';
import type { ToastTone, ToastAction } from '../ui/Toast';

export type ToastInput = {
  tone: ToastTone;
  title?: string;
  message: string;
  duration?: number; // ms (default 5000; 0 = persistente)
  action?: ToastAction;
};

export type ToastInstance = ToastInput & { id: string };

export type ToastContextValue = {
  show: (input: ToastInput) => string;
  success: (message: string, options?: Partial<ToastInput>) => string;
  error: (message: string, options?: Partial<ToastInput>) => string;
  warning: (message: string, options?: Partial<ToastInput>) => string;
  info: (message: string, options?: Partial<ToastInput>) => string;
  dismiss: (id: string) => void;
};

export const ToastContext = createContext<ToastContextValue | null>(null);
